<template>
  <v-col sm="10" cols="10">
    <div class="text-center display-2 mb-5">Welcome to Hermes 2.0</div>
    <v-row justify="center">
      <v-col sm="8">
        <v-card class="elevation-5">
          <v-toolbar flat dense>
            <v-toolbar-title>SLACK</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="font-italic body-2">
            Hermes integrates with the Slack chat app. Join the Forge Nano
            workspace by downloading the slack client online.
          </v-card-text>
          <v-card-text>
            <b># hermes</b> Here you can find the main Hermes bot which
            currently provides notifcations regarding new projects being
            updated. Feel free to start a thread around these updates.
          </v-card-text>
          <v-card-text>
            <b># hermes-quality</b> Here you can find Hermes notifications
            regarding QC Ticket submissions. Feel free to start a thread on any
            of these submissions for continued discourse.
          </v-card-text>
          <v-card-text>
            <b># hermes-shipping</b> Here you can find Hermes notifications
            regarding Shipping Ticket submissions. Feel free to start a thread
            on any of these submissions for continued discourse.
          </v-card-text>
          <v-card-text>
            <b># hermes-bugs</b> Report and discuss issues here.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col sm="8">
        <v-card class="elevation-5">
          <v-toolbar flat dense>
            <v-toolbar-title>BROWSER</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="font-italic">
            Hermes is compatible with Firefox or Google Chrome. Hermes is NOT
            comptabible with MS Edge at this time. Chrome is recommended.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col sm="8">
        <v-card class="elevation-5">
          <v-toolbar flat dense>
            <v-toolbar-title>LABELS</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            Hermes uses Dymo Label Printers to enable fast and error-less label
            generation. In order to find connected Dymo Printers you must have
            the latest verison of Dymo Label Printer (8.7 or greater) installed
            on your local client. Additionally, you may need to configure the
            Dymo web portal located in the bottom right of your computer taskbar
            (assuming Dymo Labels are installed) Double check your Dymo
            environment with the following link:
            <br />
            <v-btn
              href="http://labelwriter.com/software/dls/sdk/samples/js/CheckEnvironment/CheckEnvironment.html"
              >Dymo</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "BareLanding"
};
</script>
